<template>
  <div class="pt-3 pb-3">
    <div class="text-center"  v-if="isLoading">
			<img src="@/assets/loading-logo-animation.gif" style="width: 75px"/>
			
			<p class="font-weight-bold">{{$t('THE_SYSTEM_IS_LOADING')}}</p>
		</div>
    <v-row v-if="!isLoading" class="mx-0">
      <v-col sm="4">
        <label class="pb-1">{{ $t("METADATA") }}</label>
        <v-autocomplete
          item-text="text"
          item-value="value"
          :items="popupBatchUpdate.restriction.listMetaData"
          v-model="currentMetaData"
          outlined
          dense
          class="metadata"
		  @change="($event) => changeCurrentMetaData($event)"
        >
          <template slot="no-data">
            <div class="no-data">{{ $t("NO_DATA") }}</div>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row v-if="!isLoading" class="mx-0">
      <v-col sm="4">
        <label class="pb-1">{{ $t("ROOM_TYPE") }} *</label>
        <v-autocomplete
          @change="changeRoomSelect(currentRoomDefault)"
          item-text="text"
          item-value="value"
          :items="popupBatchUpdate.restriction.listRoomDefault"
          v-model="currentRoomDefault"
          outlined
          chips
          dense
          multiple
        >
        <template v-slot:prepend-item>
            <p class="mx-3 mt-1"> <a
            class="text-primary"
            @click="currentRoomDefault = popupBatchUpdate.restriction.listRoomDefault.map(e => e.value); changeRoomSelect(currentRoomDefault)"
            >{{$t('SELECT_ALL')}}</a> | <a
            class="text-primary"
            @click="currentRoomDefault = []; changeRoomSelect(currentRoomDefault)"
            >{{$t('UN_SELECT_ALL')}}</a>
            </p>
          </template>
          <template v-slot:selection="{ item, index }">
            <v-chip color="primary" v-if="index === 0" v-bind="item.attrs"
            :input-value="item.selected"
            close
            @click:close="removeChips(index, currentRoomDefault); changeRoomSelect(currentRoomDefault)"
            @click="item.select; changeRoomSelect(currentRoomDefault)">
            <span>{{ item.text }}</span>
            </v-chip>
            <span v-if="index === 1" class="grey--text caption"
            >(+{{ currentRoomDefault.length - 1 }})</span
            >
          </template>
          <template slot="no-data">
            <div class="no-data">{{ $t("NO_DATA") }}</div>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col sm="4">
        <label class="pb-1"> {{
					$t("SALE_PACKAGE") }} *</label>
				<v-autocomplete item-text="text" item-value="value" :items="planList" v-model.lazy="planSelect" outlined
					chips dense multiple @change="changeRoomSelect(currentRoomDefault)">
					<template v-slot:prepend-item>
						<p class="mx-3 mt-1"> <a class="text-primary" @click="planSelect = planList.map(e => e.value); changeRoomSelect(currentRoomDefault)">{{
							$t('SELECT_ALL') }}</a> | <a class="text-primary" @click="planSelect = []; changeRoomSelect(currentRoomDefault)">{{
		$t('UN_SELECT_ALL') }}</a>
						</p>
					</template>
					<template v-slot:selection="{ item, index }">
						<v-chip color="primary" v-if="index === 0" v-bind="item.attrs"
							:input-value="item.selected" close @click:close="removeChips(index, planSelect); changeRoomSelect(currentRoomDefault)"
							@click="item.select; changeRoomSelect(currentRoomDefault)">
							<span>{{ item.text }}</span>
						</v-chip>
						<span v-if="index === 1" class="grey--text caption">(+{{ planSelect.length - 1 }})</span>
					</template>
					<template slot="no-data">
						<div class="no-data">{{ $t("NO_DATA") }}</div>
					</template>
				</v-autocomplete>
      </v-col>
      <v-col sm="4">
        <label class="pb-1"> {{
					$t("SALE_CHANNEL") }} *</label>
				<v-autocomplete item-text="text" item-value="value" :items="(currentMetaData === 'minBookingWindow' || currentMetaData === 'maxBookingWindow') ? listOTA.filter(x => x.text === 'ezBe') : listOTA" v-model.lazy="popupBatchUpdate.restriction.applyOTA" outlined
					chips dense multiple>
					<template v-slot:prepend-item>
						<p class="mx-3 mt-1"> <a class="text-primary" @click="popupBatchUpdate.restriction.applyOTA = listOTA.map(e => e.value)">{{
							$t('SELECT_ALL') }}</a> | <a class="text-primary" @click="popupBatchUpdate.restriction.applyOTA = []">{{
		$t('UN_SELECT_ALL') }}</a>
						</p> 
					</template>
					<template v-slot:selection="{ item, index }">
						<v-chip color="primary" v-if="index === 0" v-bind="item.attrs"
							:input-value="item.selected" close @click:close="removeChips(index, popupBatchUpdate.restriction.applyOTA)"
							@click="item.select">
							<span>{{ item.text }}</span>
						</v-chip>
						<span v-if="index === 1" class="grey--text caption">(+{{ popupBatchUpdate.restriction.applyOTA.length - 1 }})</span>
					</template>
					<template slot="no-data">
						<div class="no-data">{{ $t("NO_DATA") }}</div>
					</template>
				</v-autocomplete>
      </v-col>
    </v-row>
    <div class="config-price mt-3" v-if="!isLoading && !isLoadType">
      <template>
        <div class="d-sticky h-header-table d-flex">
          <div class="mr-auto font-weight-bold text-primary text-uppercase d-flex align-items-center pl-3">
            {{ $t("_BATCH_UPDATE.ROOM_TYPE_AND_SALE_PACKAGE") }}</div> 
          <div class="pb-0 pt-0"> 	
            <div class="small-gutters d-flex"> 	
              <div class="text-center font-weight-bold" style="width: 94px" v-for="item in popupBatchUpdate.daysOfWeek" >{{ item.value }}</div>	
            </div> 
          </div> 
        </div>
        <v-row class="mt-0 mx-0" v-for="(room, roomIndex) in editedItemDefault">
          <v-col md="12" class="pb-0 pt-2">
            <b-row>
              <v-col md="7" class="pb-0">
                <div
                  class="d-flex align-center h-100 font-weight-bold fs-12 text-primary"
                >
                  {{ room.romTypeNameI18ns.find((x) => x.lang == defaultI18n).name }} /
                  {{ room.romPlanNameI18ns.find((x) => x.lang == defaultI18n).name }}
                </div>
              </v-col>
              <v-col md="5" class="pb-0 text-right">
                <v-btn
                  x-small
                  color="primary"
                  :title="$t('COPY')"
                  @click="copyMaster(room.fromTo)"
                >
                <i class="icon-copy_all fs-16"></i>
                </v-btn>
                <v-btn
                  x-small
                  class="ml-1"
                  color="primary"
                  :title="$t('PASTE')"
                  @click="pasteMaster(room)"
                  v-if="objectCopy"
                >
                  <i class="icon-content_paste fs-16"></i>
                </v-btn>
              </v-col>
            </b-row>
            <div class="mt-1">
              <template v-for="(date, indDate) in room.fromTo">
                <div class="align-center mt-0 mb-1 d-flex">
                  <div class="pb-0 pt-0 pr-0 fs-12 d-date d-flex align-items-center mr-auto">
                    <div class="mr-auto w-100">
                      <template v-if="roomIndex === 0">
                        <div class="d-flex align-items-center">
                          <date-picker
                            :disabled-date="notBeforeToday"
                            @input="changDate(room)"
                            :confirm="true"
                            :confirm-text="$t('CONFIRM')"
                            :clearable="false"
                            :popup-class="'popup-calendar-desktop-detailhotel'"
                            v-model="date.dateSelect"
                            :lang="languageDate"
                            :format="'DD/MM/YYYY'"
                            :shortcuts="[]"
                            range
                            placeholder="Select date range"
                          >
                          </date-picker>
                          <i v-if="room.fromTo.length > 1" class="icon-delete text-danger fs-16 ml-2 cursor" @click="removePeriodRestriction(indDate)"></i>
                        </div>
                      </template>
                      <template v-else>
                        {{ _moment(date.dateSelect[0]).format("DD/MM/YYYY") }} -
                        {{ _moment(date.dateSelect[1]).format("DD/MM/YYYY") }}
                      </template>
                    </div>
                    
                  </div>
                  <div>
                    <div
                      class="small-gutters"
                      v-if="date.restrictions.length > 0"
                    >
                    <i class="icon-content_paste_go text-primary fs-16 mr-2 cursor"  @click="copyRestriction(date)" :title="$t('COPY')"></i>
                      <div
                        v-for="(itemRestriction, index) in date.restrictions"
                        :class="index === date.restrictions.length -1 ? 'mr-0': ''"
                      >
                        <div
                          :class="
                            currentMetaData == 'cutOfTime'
                              ? 'cutOftime'
                              : ''
                          "
                        >
                          <div class="relative">
                            <template v-if="isInput">
                              <input
                                class="w-input-update v-input__slot mb-0 mx-input pt-0 pb-0 pr-5 text-right"
                                currency=" "
                                v-model="itemRestriction.value"
                                :disabled="itemRestriction.disable"
                                @input="itemRestriction.value = $event.target.value.replace(/[^0-9]/g, '')"
                                :oninput="itemRestriction.value ? itemRestriction.value = Math.floor(itemRestriction.value) : ''"
                              />
                              <span class="prefix-unit">{{ (currentMetaData === 'minBookingWindow' || currentMetaData === 'maxBookingWindow') ? 'D' : (currentMetaData === 'minBookingWindowByHour' || currentMetaData === 'maxBookingWindowByHour') ? 'H' : '' }}</span>
                              <!-- <number-ptd 
                                class="w-input-update"
                                :options="(currentMetaData === 'minBookingWindow' || currentMetaData === 'maxBookingWindow') ? unitByDate : (currentMetaData === 'minBookingWindowByHour' || currentMetaData === 'maxBookingWindowByHour') ? unitByHour : ''"
                                :outlined="true"
                                v-model="itemRestriction.value"
                                :disabled="itemRestriction.disable"
                              /> -->
                            </template>
                            <template
                              v-else
                            >
                            <b-form-select
                              class="w-input-update"
                              v-model="itemRestriction.value"
                              :options="popupBatchUpdate.restriction.closeList"
                              value-field="value"
                              text-field="text"
                              :disabled="itemRestriction.disable"
                              size="sm"
                            ></b-form-select>
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <v-row class="mt-0" v-if="roomIndex === 0">
                <v-col class="pt-0 pb-0">
                  <v-btn
                    color="primary"
                    outlined
                    x-small
                    @click="addDatePriodRestriction()"
                  >
                    <v-icon color="#173d8f" small>add</v-icon>
                    <span class="fs-8">{{ $t("ADD_DATE_RANGE") }}</span>
                  </v-btn>
                </v-col>
              </v-row>
              <hr class="mb-0" />
            </div>
          </v-col>
        </v-row>
      </template>
      <template v-if="editedItemDefault.length === 0">
        <v-col class="text-center">
          <p>{{ $t("NO_DATA") }}</p>
        </v-col>
      </template>
    </div>
    <p class="font-weight-bold text-center pt-3"  v-if="isLoadType && !isLoading">{{$t('THE_SYSTEM_IS_LOADING')}}</p>
    <div class="text-right pt-3 mx-3" v-if="!isLoading">
      <v-btn color="primary" @click="confirmUpdateRestriction()">
        <template>{{ $t("UPDATE") }}</template>
      </v-btn>
    </div>
    <v-dialog v-model="dialogWarning" :persistent="true" width="500" >
      <v-toolbar class="toolbar-update" dense >
        <v-toolbar-title class="text-primary fs-15">
          <strong>{{ $t('WARNING') }}</strong>
        </v-toolbar-title>
      </v-toolbar>
      <div class="content-update">
        <label class="s-label">
          {{ $t('TXT_WARNING_OVER') }}
        </label>
        <div class="mt-3 text-center">
          <!-- <div class="w-100 mr-1">
            <v-btn depressed block @click="close">
              {{ $t("_LOGIN.CANCEL") }}
            </v-btn>
          </div> -->
            <v-btn color="primary" @click="closeWarning">
              {{ $t("CONFIRM") }}
            </v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>
<script>
import moment from "moment";
import { _alert } from "@/_helpers/function.js";
import { syncota } from "@/_services/SyncOTA/syncota.js";
import { restriction } from "@/_services/SaleRoom/restriction.js";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Input from "@/components/Utils/Input.vue";
import VueNumeric from "vue-numeric";
import numberInput from "@/components/Utils/Number-input.vue";
export default {
  components: {
    "date-picker": DatePicker,
    "input-text": Input,
    VueNumeric,
    "currency-ptd": () => import('@/components/Utils/Currency-input.vue'),
    "number-ptd": numberInput
  },
  data() {
    return {
      numberOption: {
        suffix: "",
        locale: "vi",
        length: 3,
        precision: 0,
      },
	  isLoading: true,
      popupBatchUpdate: {
        
        restriction: {
          invalidDate: false,
          closeList: [
            {
              text: this.$t("NO"),
              value: "",
            },
            {
              text: this.$t("OPEN"),
              value: false,
            },
            {
              text: this.$t("CLOSE"),
              value: true,
            },
          ],
          listMetaData: [
            {
              text: this.$t("minStay"),
              value: "minStay",
            },
            {
              text: this.$t("maxStay"),
              value: "maxStay",
            },
            {
              text: this.$t("minStayArrival"),
              value: "minStayArrival",
            },
            {
              text: this.$t("maxStayArrival"),
              value: "maxStayArrival",
            },
            {
              text: this.$t("minBookingWindow"),
              value: "minBookingWindow",
            },
            {
              text: this.$t("maxBookingWindow"),
              value: "maxBookingWindow",
            },
            {
              text: this.$t("minBookingWindowByHour"),
              value: "minBookingWindowByHour",
            },
            {
              text: this.$t("maxBookingWindowByHour"),
              value: "maxBookingWindowByHour",
            },
            {
              text: this.$t("exactStay"),
              value: "exactStay",
            },
            {
              text: this.$t("exactStayArrival"),
              value: "exactStayArrival",
            },
            {
              text: this.$t("closedOnArrival"),
              value: "closedOnArrival",
            },
            {
              text: this.$t("closedOnDeparture"),
              value: "closedOnDeparture",
            },
            {
              text: this.$t("closed"),
              value: "closed",
            },
          ],
          editType: "default",
          listRoomDefault: [],
          listRestriction: [],
          
          currentRestriction: null,
          
          editedItemDefaultAll: [],
          editedItemDefault: [],
          listOfPeriod: [],
          
          applyOTA: [],
        },
        daysOfWeek: [
          { code: "MON", value: this.$t("MONDAY") },
          { code: "TUE", value: this.$t("TUESDAY") },
          { code: "WED", value: this.$t("WEDNESDAY") },
          { code: "THU", value: this.$t("THURSDAY") },
          { code: "FRI", value: this.$t("FRIDAY") },
          { code: "SAT", value: this.$t("SATURDAY") },
          { code: "SUN", value: this.$t("SUNDAY") },
        ],
      },
      systemLang: this.$i18n.locale,
      listOTA: [],
      objectCopy: null,
      currency: this.usedCurrency,
      selectAll: false,
	  editedItemDefault: [],
	  currentRoomDefault: [],
	  inputList: [
            "minStay",
            "maxStay",
            "minStayArrival",
            "maxStayArrival",
            "minBookingWindow",
            "minBookingWindowByHour",
            "maxBookingWindow",
            "maxBookingWindowByHour",
            "exactStay",
            "exactStayArrival",
          ],
    	selectList: ["closed", "closedOnArrival", "closedOnDeparture"],
		currentMetaData: "minStay",
		isInput: true,
    planSelect: [],
    planList: [],
    dialogWarning: false,
    isLoadType: false,
    };
  },
  created() {
    this.currency = this.usedCurrency;
    this.isLoading = true;
    if (
      this.$route.query &&
      this.$route.query.metaData
    ) {
      this.currentMetaData = this.$route.query.metaData;
    }
	this.changeCurrentMetaData(this.currentMetaData);
    syncota.getAllOTA({ keyword: "", status: 1 }).then((res) => {
      if (res.responseCode === 0) {
        this.listOTA = res.data.map((x) => {
          return {
            value: x.id,
            text: x.otaI18n.find((y) => y.lang == this.defaultI18n).name,
          };
        });
        this.listOTA = this.listOTA.filter((x) => x.value);
        this.listOTA.sort((a, b) => a.text.localeCompare(b.text));
        const params = JSON.parse(localStorage.getItem("roomRateUpdate"));
        if (params.OtaId && params.OtaId == -1) {
          this.popupBatchUpdate.restriction.applyOTA = this.listOTA.map(e => e.value);
        } else if (params.OtaId) {
          this.popupBatchUpdate.restriction.applyOTA = this.listOTA.length > 0 && this.listOTA.find((x) => x.value == params.OtaId) ? [this.listOTA.find((x) => x.value == params.OtaId).value] : [];
        } else {
          this.popupBatchUpdate.restriction.applyOTA = [];
        }
        this.getAllRoomDefault();
      } else {
        _alert(res, this.$t(res.data), false);
      }
    });
  },
  watch: {
    popupBatchUpdate: {
      handler(val) {
        val.restriction.editedItemDefault.forEach((room) => {
          room.fromTo.forEach((date) => {
            var start = moment(date.dateSelect[0], "YYYY-MM-DD");
            var end = moment(date.dateSelect[1], "YYYY-MM-DD");

            // Kiểm tra khoảng ngày hiện tại có lớn hơn 7, nếu lớn hơn thì enable tất cả, nếu ko thì xem khoảng ngày có ngày nào.
            let day = moment.duration(end.diff(start)).asDays();

            // Reset lại toàn bộ
            if (day < 6) {
              while (start <= end) {
                let daysOfWeek = start.day() === 0 ? 7 : start.day();
                // Mở các thứ ở trong khoảng
                date.restrictions.find((e) => e.dayOfWeek === daysOfWeek).disable = false;
                start = moment(start).add(1, "day");
              }
            } else {
              // Nếu khoảng ngày trải dài cả tuần thì mở hết.
              date.restrictions.forEach((e) => {
                e.disable = false;
              });
            }
          });
        });
        if (val.restriction.applyOTA.length !== this.listOTA.length) {
          this.selectAll = false;
        } else {
          this.selectAll = true;
        }
      },
      deep: true,
    },
    currentMetaData: {
      handler(val) {
        if (val === 'minBookingWindow' || val === 'maxBookingWindow') {
          this.popupBatchUpdate.restriction.applyOTA = [];
          this.popupBatchUpdate.restriction.applyOTA.push(this.listOTA.find(x => x.text === 'ezBe').value);
        }
      }
    }
  },
  methods: {
	changeCurrentMetaData(data) {
      this.isLoadType = true;
			this.isInput = this.inputList.includes(data);
      setTimeout(() => {
        this.isLoadType = false;
      }, 1000);
	},
	changeRoomSelect(data) {
    let dataUpdate = this.popupBatchUpdate.restriction.editedItemDefault.filter((e) =>
				data.includes(e.roomTypeId) && this.planSelect.includes(e.ratePlanId)
			);
    if (dataUpdate.length <= 50) {
      this.editedItemDefault = [...dataUpdate];
    } else {
      this.dialogWarning = true;
      this.editedItemDefault = []
    }
    this.isLoadType = true;
      setTimeout(() => {
        this.isLoadType = false;
      }, 1000);
	},
  closeWarning() {
    this.planSelect = [];
    this.dialogWarning = false
  },
    checkAll() {
      this.popupBatchUpdate.restriction.applyOTA = [];
      if (this.selectAll) {
        this.listOTA.forEach((e) => {
          this.popupBatchUpdate.restriction.applyOTA.push(e.value);
        });
      } else {
        this.popupBatchUpdate.restriction.applyOTA = [];
      }
    },
    async getAllRoomDefault() {
      this.planList = []
      await restriction.getAllRoomTyeHasRoomRate().then((res) => {
        if (res.responseCode == 0) {
          let fromDateListOfPeriod = moment(this.currentDate).format("YYYY-MM-DD");
          let toDateListOfPeriod = moment(this.currentDate)
            .add(1, "day")
            .format("YYYY-MM-DD");
          this.popupBatchUpdate.restriction.listRoomDefault = [];

          this.popupBatchUpdate.restriction.listRoomDefault = this.popupBatchUpdate.restriction.listRoomDefault.concat(
            res.data.map((x) => {
              return {
                value: x.id,
                text: x.roomTypeI18n.find((y) => y.lang == this.defaultI18n).name,
              };
            })
          );
          this.popupBatchUpdate.restriction.listRoomDefault = this.popupBatchUpdate.restriction.listRoomDefault.filter(
            (x) => x.value
          );

          res.data.forEach((x) => {
            x.ratePlans.forEach((y) => {
              let plan = {
								value: y.id,
								text: y.i18ns.find((y) => y.lang == this.defaultI18n).name,
							};
							this.planList.push(plan);
							this.planList = Array.from(new Set(this.planList.map(JSON.stringify))).map(JSON.parse)
              this.popupBatchUpdate.restriction.editedItemDefault.push({
                romTypeNameI18ns: x.roomTypeI18n,
                romPlanNameI18ns: y.i18ns,
                roomTypeId: x.id,
                ratePlanId: y.id,
                restrictionPlanId: null,
                fromTo: [],
                updateField: "minStay",
              });
            });
          });
          const params = JSON.parse(localStorage.getItem("roomRateUpdate"));
          if (params.roomId) {
            if (params.roomId != -1) {
              this.currentRoomDefault = [params.roomId];
              this.planSelect = [params.planId]
            } else {
              // this.currentRoomDefault = this.popupBatchUpdate.restriction.listRoomDefault.map(e => e.value);
              this.planSelect = [];
            }
            
          } else {
            this.currentRoomDefault.push(
              this.popupBatchUpdate.restriction.listRoomDefault[0].value
            );
          }
		  this.changeRoomSelect(this.currentRoomDefault)

          // Thêm khoảng ngày mặc định cho phòng và gói bán.
          this.popupBatchUpdate.restriction.editedItemDefault.forEach((x) => {
            x.fromTo.push({
              dateSelect: [new Date(fromDateListOfPeriod), new Date(toDateListOfPeriod)],
              restrictions: [
                {
                  dayOfWeek: 1,
                  value: "",
                  disable: true,
                  
                },
                {
                  dayOfWeek: 2,
                  value: "",
                  disable: true,
                  
                },
                {
                  dayOfWeek: 3,
                  value: "",
                  disable: true,
                  
                },
                {
                  dayOfWeek: 4,
                  value: "",
                  disable: true,
                  
                },
                {
                  dayOfWeek: 5,
                  value: "",
                  disable: true,
                  
                },
                {
                  dayOfWeek: 6,
                  value: "",
                  disable: true,
                  
                },
                {
                  dayOfWeek: 7,
                  value: "",
                  disable: true,
                  
                },
              ],
            });
          });
          this.getAllRestriction();
        }
      });
    },
    addDatePriodRestriction() {
      let prevPeriod = this.popupBatchUpdate.restriction.editedItemDefault[0].fromTo[
        this.popupBatchUpdate.restriction.editedItemDefault[0].fromTo.length - 1
      ];
      const tomorrow = new Date();
      tomorrow.setDate(new Date().getDate() + 365 * 2);
      if (new Date(moment(prevPeriod.dateSelect[1]).format("YYYY-MM-DD")) >= tomorrow) {
        return;
      }
      let from = moment(prevPeriod.dateSelect[1]).add(1, "day").format("YYYY-MM-DD");
      let to = moment(prevPeriod.dateSelect[1]).add(2, "day").format("YYYY-MM-DD");
      this.popupBatchUpdate.restriction.editedItemDefault.forEach((room) => {
        room.fromTo.push({
          dateSelect: [new Date(from), new Date(to)],
          restrictions: [
            {
              dayOfWeek: 1,
              value: "",
              disable: true,
              
            },
            {
              dayOfWeek: 2,
              value: "",
              disable: true,
              
            },
            {
              dayOfWeek: 3,
              value: "",
              disable: true,
              
            },
            {
              dayOfWeek: 4,
              value: "",
              disable: true,
              
            },
            {
              dayOfWeek: 5,
              value: "",
              disable: true,
              
            },
            {
              dayOfWeek: 6,
              value: "",
              disable: true,
              
            },
            {
              dayOfWeek: 7,
              value: "",
              disable: true,
              
            },
          ],
        });
      });
    },
    copyMaster(detail) {
      this.objectCopy = [...detail];
    },
    pasteMaster(detail) {
      if (this.objectCopy) {
        this.objectCopy.forEach((element, index) => {
          detail.fromTo[index].restrictions[0].value = element.restrictions[0].value;
          detail.fromTo[index].restrictions[1].value = element.restrictions[1].value;
          detail.fromTo[index].restrictions[2].value = element.restrictions[2].value;
          detail.fromTo[index].restrictions[3].value = element.restrictions[3].value;
          detail.fromTo[index].restrictions[4].value = element.restrictions[4].value;
          detail.fromTo[index].restrictions[5].value = element.restrictions[5].value;
          detail.fromTo[index].restrictions[6].value = element.restrictions[6].value;
        });
      }
    },
    changDate(room) {
      let arrDate = [];
      room.fromTo.forEach((element) => {
        arrDate.push(element.dateSelect);
      });
      this.popupBatchUpdate.restriction.editedItemDefault.forEach((room) => {
        room.fromTo.forEach((date, index) => {
          date.restrictions.forEach((e) => {
            e.disable = true;
          });
          date.dateSelect = arrDate[index];
        });
      });
    },
    removePeriodRestriction(index) {
      this.popupBatchUpdate.restriction.editedItemDefault.forEach((room) => {
        room.fromTo.splice(index, 1);
      });
    },
    copyRestriction(date) {
      var value = null;
      if (!date.restrictions[0].disable) {
        value = date.restrictions[0].value;
      } else if (!date.restrictions[1].disable) {
        value = date.restrictions[1].value;
      } else if (!date.restrictions[2].disable) {
        value = date.restrictions[2].value;
      } else if (!date.restrictions[3].disable) {
        value = date.restrictions[3].value;
      } else if (!date.restrictions[4].disable) {
        value = date.restrictions[4].value;
      } else if (!date.restrictions[5].disable) {
        value = date.restrictions[5].value;
      } else if (!date.restrictions[6].disable) {
        value = date.restrictions[6].value;
      }
      date.restrictions[0].value = !date.restrictions[0].disable ? value : "";
      date.restrictions[1].value = !date.restrictions[1].disable ? value : "";
      date.restrictions[2].value = !date.restrictions[2].disable ? value : "";
      date.restrictions[3].value = !date.restrictions[3].disable ? value : "";
      date.restrictions[4].value = !date.restrictions[4].disable ? value : "";
      date.restrictions[5].value = !date.restrictions[5].disable ? value : "";
      date.restrictions[6].value = !date.restrictions[6].disable ? value : "";
    },
    getAllRestriction() {
      this.loading = true;
      let body = {};
      body.keyword = "";
      body.status = 1;
      body.limit = 100;
      body.offset = 0;
      body.orderBy = "active";
      body.asc = true;

      restriction.getAllPackageRestriction(body).then((res) => {
        if (res.responseCode == 0) {
          this.popupBatchUpdate.restriction.listRestriction = res.data.map((x) => {
            return {
              value: x.id,
              text: x.nameVi,
            };
          });
          this.popupBatchUpdate.restriction.listRestriction = this.popupBatchUpdate.restriction.listRestriction.filter(
            (x) => x.value
          );

          if (this.popupBatchUpdate.restriction.listRestriction.length > 0) {
            this.popupBatchUpdate.restriction.currentRestriction = this.popupBatchUpdate.restriction.listRestriction[0].value;
          }
        }
        this.loading = false;
        this.isLoading = false;
      });
    },
    confirmUpdateRestriction() {
      if (this.currentRoomDefault.length === 0 || this.planSelect.length === 0 || this.popupBatchUpdate.restriction.applyOTA.length === 0) {
        _alert("null", this.$t("PLEASE_COMPLETE_THE_FIELDS_MARKED"));
        return
      }
      let noted;
      let check = false;
      this.editedItemDefault[0].fromTo.forEach((x) => {
        if (this.get_day_of_time(new Date(x.dateSelect[0]), new Date(x.dateSelect[1])) > 365) {
          _alert(null, this.$t("UPDATE_INTERVAL_IS_NOT_MORE_THAN_ONE_YEAR"));
          check = true;
          return true;
        }
        if (!noted) {
          noted = moment(x.dateSelect[1], "YYYY/MM/DD");
          return true;
        }
        if (moment(x.dateSelect[0], "YYYY/MM/DD") <= noted) {
          check = true;
          _alert(null, this.$t("_BATCH_UPDATE.MESSAGE.OVERLAP_TIME"));
        }
      });

      if (!this.popupBatchUpdate.restriction.currentRestriction) {
        _alert(null, this.$t("ERROR"));
      }

      const data = [];
      if (this.popupBatchUpdate.restriction.editType == "default") {
        let arr = JSON.parse(
          JSON.stringify(this.editedItemDefault)
        );
        for (let x of arr) {
          for (let y of x.fromTo[0].restrictions) {
            if (y.value &&
              (this.currentMetaData === 'minBookingWindowByHour' || this.currentMetaData === 'maxBookingWindowByHour') &&
              !y.disable && +y.value >= 24
            ) {
              _alert(null, this.$t("VALUE_MUST_BE_LESS_THAN_24H"));
              return;
            }
          }
        }
        arr.forEach((x) => {
          x.fromTo = x.fromTo.map((e) =>
            Object.assign(
              {},
              {
                dateStart: moment(e.dateSelect[0]).format("YYYY-MM-DD"),
                dateEnd: moment(e.dateSelect[1]).format("YYYY-MM-DD"),
                restrictions: e.restrictions,
              }
            )
          );
          if (this.popupBatchUpdate.restriction.applyOTA.length > 0) {
            this.popupBatchUpdate.restriction.applyOTA.forEach((y) => {
              data.push({
                otaId: y,
                roomTypeId: x.roomTypeId,
                ratePlanId: x.ratePlanId,
                restrictionPlanId: this.popupBatchUpdate.restriction.currentRestriction,
                fromTo: x.fromTo,
                updateField: this.currentMetaData,
              });
            });
          }
        });
      }

      if (
        this.popupBatchUpdate.restriction.applyOTA.length > 0 &&
        !this.popupBatchUpdate.restriction.invalidDate &&
        !check
      ) {
        this.isLoading = true;

        restriction
          .batchUpdate(data)
          .then((res) => {
            _alert(res, this.$t(res.data), true);
          })
          .finally(() => (this.isLoading = false));
      } else {
        _alert("null", this.$t("CHANNEL_EMPTY"));
      }
    },
    _moment: moment,
  },
};
</script>
<style scoped>
.relative {
  position: relative;
}
.pr-5 {
  padding-right: 5px;
}
  .prefix-unit {
    position: absolute;
    top: 22%;
    right: 7px;
  }
</style>